// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container general */
.SearchBar_container__RfG9c {
  max-width: 1140px;
  margin: 0 auto; /* Centrare pe orizontală */
  display: flex;
  justify-content: center; /* Centrează bara în container */
}

/* Bara de căutare */
.SearchBar_searchBar__4E1N5 {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 15px;
}

/* Câmpul de căutare */
.SearchBar_searchInput__cXYAd {
  display: flex;
  align-items: center;
  background-color: transparent; /* Fără culoare de fundal */
  border: none; /* Elimină marginea */
  border-radius: 5px;
  /* overflow: hidden; */
  position: relative;
}

.SearchBar_input__-V5af {
  border: 1px solid #ccc; /* Adaugă o margine doar pentru input */
  border-right: none; /* Elimină marginea din partea dreaptă */
  border-radius: 5px 0 0 5px; /* Rotunjire doar pentru colțurile stânga sus și jos */
  padding: 8px;
  font-size: 14px;
  width: 200px; /* Dimensiune fixă pentru câmpul de căutare */
  outline: none;
}

.SearchBar_searchButton__PIkWD {
  background-color: #d32f2f;
  color: white;
  border: none;
  border-left: none; /* Elimină marginea din partea dreaptă */
  border-radius: 0 5px 5px 0; /* Rotunjire doar pentru colțurile stânga sus și jos */
  padding: 8px 12px;
  cursor: pointer;
  font-size: 16px;
}

.SearchBar_searchButton__PIkWD:hover {
  background-color: #b71c1c;
}

/* Stil pentru dropdown */
.SearchBar_sortDropdown__wCdKV select {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 8px;
  font-size: 14px;
  cursor: pointer;
}

/* Culoare pe hover pentru opțiuni */
.SearchBar_sortDropdown__wCdKV select option:hover {
  background-color: #d32f2f; /* Roșu */
  color: white; /* Text alb pentru contrast */
}

.SearchBar_resultsContainer__daW-S {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ccc;
  background-color: #fff;
  z-index: 10;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.SearchBar_resultItem__MN8qd {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
  text-decoration: none;
}

.SearchBar_resultItem__MN8qd:hover {
  background-color: #f9f9f9;
}

.SearchBar_resultImage__u\\+fiU {
  width: 50px;
  height: 50px;
  object-fit: cover;
  margin-right: 10px;
  border-radius: 4px;
}

.SearchBar_resultName__toRJD {
  color: black;
  font-size: 16px;
  font-weight: bold;
  margin: 0;
}

.SearchBar_resultDetails__ow5zc {
  font-size: 14px;
  color: #555;
  margin: 5px 0;
}

.SearchBar_resultPrice__\\+xkH1 {
  font-size: 14px;
  color: #e53935;
  font-weight: bold;
}

.SearchBar_noResults__J\\+mHA {
  padding: 5px;
  font-size: 18px;
  text-align: center;
  color: #888;
}

/* Stiluri pentru ecrane mici */
@media (max-width: 768px) {
  /* Container general */
  .SearchBar_container__RfG9c {
    display: flex;
    align-items: stretch; /* Elemente ocupă întreaga lățime */
    padding: 10px; /* Spațiu suplimentar */
    box-sizing: border-box;
  }

  /* Bara de căutare */
  .SearchBar_searchBar__4E1N5 {
    flex-direction: row; /* Elemente pe verticală */
    gap: 10px; /* Spațiu între input și dropdown */
    width: 100%; /* Lățime completă în container */
  }

  /* Inputul de căutare */
  .SearchBar_searchInput__cXYAd {
    width: 80%; /* Ocupă întreaga lățime a containerului */
  }

  .SearchBar_input__-V5af {
    width: 100%; /* Ajustare pentru lățime completă */
        border-top-left-radius: 5px; 
    border-bottom-left-radius: 5px; 
  }

  .SearchBar_searchButton__PIkWD {
    border-top-right-radius: 5px; 
    border-bottom-right-radius: 5px; 
  }

  /* Dropdown-ul de sortare */
  .SearchBar_sortDropdown__wCdKV {
    width: 10%; /* Ocupă întreaga lățime */
  }

  .SearchBar_sortDropdown__wCdKV select {
    width: 100%; /* Ajustare pentru a se potrivi în container */
    border-radius: 5px; /* Rotunjire uniformă */
  }

  /* Rezultatele căutării */
  .SearchBar_resultsContainer__daW-S {
    width: 100%; /* Asigură alinierea în container */
    max-height: 300px; /* Înălțime maximă */
  }

  .SearchBar_resultItem__MN8qd {
    flex-direction: row; /* Afișează imaginea și detaliile pe un rând */
  }

  .SearchBar_sortIcon__p\\+763 {
      background: none;
      border: none;
      cursor: pointer;
  }

  .SearchBar_sortDropdown__wCdKV {
      position: relative;
  }

  .SearchBar_sortOptions__xWiCc {
      position: absolute;
      top: 40px; /* Ajustează în funcție de înălțimea icon-ului */
      right: 0px;
      background-color: white;
      border: 1px solid #ccc;
      border-radius: 4px;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
      z-index: 10;
      padding: 10px;
      width: 150px;
  }

  .SearchBar_sortOptions__xWiCc button {
      display: block;
      width: 100%;
      background: none;
      border: none;
      text-align: left;
      padding: 5px 10px;
      cursor: pointer;
      font-size: 14px;
      margin: 3px;
  }

  .SearchBar_sortOptions__xWiCc button:hover {
      background-color: #f5f5f5;
  }

}
`, "",{"version":3,"sources":["webpack://./src/components/Products/SearchBar/SearchBar.module.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,cAAc,EAAE,2BAA2B;EAC3C,aAAa;EACb,uBAAuB,EAAE,gCAAgC;AAC3D;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B,EAAE,2BAA2B;EAC1D,YAAY,EAAE,qBAAqB;EACnC,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB,EAAE,uCAAuC;EAC/D,kBAAkB,EAAE,wCAAwC;EAC5D,0BAA0B,EAAE,sDAAsD;EAClF,YAAY;EACZ,eAAe;EACf,YAAY,EAAE,6CAA6C;EAC3D,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB,EAAE,wCAAwC;EAC3D,0BAA0B,EAAE,sDAAsD;EAClF,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB,EAAE,SAAS;EACpC,YAAY,EAAE,6BAA6B;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB;IACE,aAAa;IACb,oBAAoB,EAAE,mCAAmC;IACzD,aAAa,EAAE,uBAAuB;IACtC,sBAAsB;EACxB;;EAEA,oBAAoB;EACpB;IACE,mBAAmB,EAAE,0BAA0B;IAC/C,SAAS,EAAE,mCAAmC;IAC9C,WAAW,EAAE,iCAAiC;EAChD;;EAEA,uBAAuB;EACvB;IACE,UAAU,EAAE,0CAA0C;EACxD;;EAEA;IACE,WAAW,EAAE,oCAAoC;QAC7C,2BAA2B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA,2BAA2B;EAC3B;IACE,UAAU,EAAE,0BAA0B;EACxC;;EAEA;IACE,WAAW,EAAE,8CAA8C;IAC3D,kBAAkB,EAAE,uBAAuB;EAC7C;;EAEA,yBAAyB;EACzB;IACE,WAAW,EAAE,mCAAmC;IAChD,iBAAiB,EAAE,oBAAoB;EACzC;;EAEA;IACE,mBAAmB,EAAE,8CAA8C;EACrE;;EAEA;MACI,gBAAgB;MAChB,YAAY;MACZ,eAAe;EACnB;;EAEA;MACI,kBAAkB;EACtB;;EAEA;MACI,kBAAkB;MAClB,SAAS,EAAE,gDAAgD;MAC3D,UAAU;MACV,uBAAuB;MACvB,sBAAsB;MACtB,kBAAkB;MAClB,wCAAwC;MACxC,WAAW;MACX,aAAa;MACb,YAAY;EAChB;;EAEA;MACI,cAAc;MACd,WAAW;MACX,gBAAgB;MAChB,YAAY;MACZ,gBAAgB;MAChB,iBAAiB;MACjB,eAAe;MACf,eAAe;MACf,WAAW;EACf;;EAEA;MACI,yBAAyB;EAC7B;;AAEF","sourcesContent":["/* Container general */\n.container {\n  max-width: 1140px;\n  margin: 0 auto; /* Centrare pe orizontală */\n  display: flex;\n  justify-content: center; /* Centrează bara în container */\n}\n\n/* Bara de căutare */\n.searchBar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 15px;\n}\n\n/* Câmpul de căutare */\n.searchInput {\n  display: flex;\n  align-items: center;\n  background-color: transparent; /* Fără culoare de fundal */\n  border: none; /* Elimină marginea */\n  border-radius: 5px;\n  /* overflow: hidden; */\n  position: relative;\n}\n\n.input {\n  border: 1px solid #ccc; /* Adaugă o margine doar pentru input */\n  border-right: none; /* Elimină marginea din partea dreaptă */\n  border-radius: 5px 0 0 5px; /* Rotunjire doar pentru colțurile stânga sus și jos */\n  padding: 8px;\n  font-size: 14px;\n  width: 200px; /* Dimensiune fixă pentru câmpul de căutare */\n  outline: none;\n}\n\n.searchButton {\n  background-color: #d32f2f;\n  color: white;\n  border: none;\n  border-left: none; /* Elimină marginea din partea dreaptă */\n  border-radius: 0 5px 5px 0; /* Rotunjire doar pentru colțurile stânga sus și jos */\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.searchButton:hover {\n  background-color: #b71c1c;\n}\n\n/* Stil pentru dropdown */\n.sortDropdown select {\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 8px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n/* Culoare pe hover pentru opțiuni */\n.sortDropdown select option:hover {\n  background-color: #d32f2f; /* Roșu */\n  color: white; /* Text alb pentru contrast */\n}\n\n.resultsContainer {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  max-height: 300px;\n  overflow-y: auto;\n  border: 1px solid #ccc;\n  background-color: #fff;\n  z-index: 10;\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.resultItem {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  text-decoration: none;\n}\n\n.resultItem:hover {\n  background-color: #f9f9f9;\n}\n\n.resultImage {\n  width: 50px;\n  height: 50px;\n  object-fit: cover;\n  margin-right: 10px;\n  border-radius: 4px;\n}\n\n.resultName {\n  color: black;\n  font-size: 16px;\n  font-weight: bold;\n  margin: 0;\n}\n\n.resultDetails {\n  font-size: 14px;\n  color: #555;\n  margin: 5px 0;\n}\n\n.resultPrice {\n  font-size: 14px;\n  color: #e53935;\n  font-weight: bold;\n}\n\n.noResults {\n  padding: 5px;\n  font-size: 18px;\n  text-align: center;\n  color: #888;\n}\n\n/* Stiluri pentru ecrane mici */\n@media (max-width: 768px) {\n  /* Container general */\n  .container {\n    display: flex;\n    align-items: stretch; /* Elemente ocupă întreaga lățime */\n    padding: 10px; /* Spațiu suplimentar */\n    box-sizing: border-box;\n  }\n\n  /* Bara de căutare */\n  .searchBar {\n    flex-direction: row; /* Elemente pe verticală */\n    gap: 10px; /* Spațiu între input și dropdown */\n    width: 100%; /* Lățime completă în container */\n  }\n\n  /* Inputul de căutare */\n  .searchInput {\n    width: 80%; /* Ocupă întreaga lățime a containerului */\n  }\n\n  .input {\n    width: 100%; /* Ajustare pentru lățime completă */\n        border-top-left-radius: 5px; \n    border-bottom-left-radius: 5px; \n  }\n\n  .searchButton {\n    border-top-right-radius: 5px; \n    border-bottom-right-radius: 5px; \n  }\n\n  /* Dropdown-ul de sortare */\n  .sortDropdown {\n    width: 10%; /* Ocupă întreaga lățime */\n  }\n\n  .sortDropdown select {\n    width: 100%; /* Ajustare pentru a se potrivi în container */\n    border-radius: 5px; /* Rotunjire uniformă */\n  }\n\n  /* Rezultatele căutării */\n  .resultsContainer {\n    width: 100%; /* Asigură alinierea în container */\n    max-height: 300px; /* Înălțime maximă */\n  }\n\n  .resultItem {\n    flex-direction: row; /* Afișează imaginea și detaliile pe un rând */\n  }\n\n  .sortIcon {\n      background: none;\n      border: none;\n      cursor: pointer;\n  }\n\n  .sortDropdown {\n      position: relative;\n  }\n\n  .sortOptions {\n      position: absolute;\n      top: 40px; /* Ajustează în funcție de înălțimea icon-ului */\n      right: 0px;\n      background-color: white;\n      border: 1px solid #ccc;\n      border-radius: 4px;\n      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n      z-index: 10;\n      padding: 10px;\n      width: 150px;\n  }\n\n  .sortOptions button {\n      display: block;\n      width: 100%;\n      background: none;\n      border: none;\n      text-align: left;\n      padding: 5px 10px;\n      cursor: pointer;\n      font-size: 14px;\n      margin: 3px;\n  }\n\n  .sortOptions button:hover {\n      background-color: #f5f5f5;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SearchBar_container__RfG9c`,
	"searchBar": `SearchBar_searchBar__4E1N5`,
	"searchInput": `SearchBar_searchInput__cXYAd`,
	"input": `SearchBar_input__-V5af`,
	"searchButton": `SearchBar_searchButton__PIkWD`,
	"sortDropdown": `SearchBar_sortDropdown__wCdKV`,
	"resultsContainer": `SearchBar_resultsContainer__daW-S`,
	"resultItem": `SearchBar_resultItem__MN8qd`,
	"resultImage": `SearchBar_resultImage__u+fiU`,
	"resultName": `SearchBar_resultName__toRJD`,
	"resultDetails": `SearchBar_resultDetails__ow5zc`,
	"resultPrice": `SearchBar_resultPrice__+xkH1`,
	"noResults": `SearchBar_noResults__J+mHA`,
	"sortIcon": `SearchBar_sortIcon__p+763`,
	"sortOptions": `SearchBar_sortOptions__xWiCc`
};
export default ___CSS_LOADER_EXPORT___;
